'use client';

import { Button } from '@common/components';
import { SvgLink } from '@common/icon';

import { CustomLink } from '@/app/_components/CustomLink';
import { PRODUCT_DOMAIN } from '@/constants';
import { KB_PAY_CUSTOM_SCHEME } from '@/modules/kb-pay';
import { useDeviceInfoStore, WEBVIEW_TYPE } from '@/stores/DeviceStore';
import { gtmDatasets } from '@/utils/analytics/gtm';

interface ExternalSiteLinkButtonProps {
  href: string;
  contentName: string;
  id: string;
}

/**
 * kb webview의 외부 링크 처리를 위한 컴포넌트
 */
export const ExternalSiteLinkButton = ({
  href: originalHref,
  contentName,
  id,
}: ExternalSiteLinkButtonProps) => {
  const isKbWebview = useDeviceInfoStore(
    (state) => state.webviewType === WEBVIEW_TYPE.KB_PAY,
  );

  const href = originalHref.includes(PRODUCT_DOMAIN.replace('https://', ''))
    ? originalHref.split(PRODUCT_DOMAIN.replace('https://', ''))[1]
    : originalHref;

  const isInAppLink = href.startsWith('/');

  const convertHref = (() => {
    if (isInAppLink) return href;

    if (isKbWebview) return '';

    return href;
  })();

  const convertTarget = (() => {
    if (isInAppLink) return undefined;

    if (isKbWebview) return undefined;

    return '_blank';
  })();

  return (
    <Button asChild className="flex-1" dimensions="H40" theme="sub-line">
      <CustomLink
        aria-label="사이트로 이동"
        href={convertHref}
        target={convertTarget}
        onClick={(e) => {
          if (isKbWebview && !isInAppLink) {
            e.preventDefault();
            window.location.href = KB_PAY_CUSTOM_SCHEME.EXTERNAL_PREFIX + href;
          }
        }}
        {...gtmDatasets.clickBtn({
          btn_name: '사이트로 이동',
          content_name: contentName,
          content_id: id,
        })}
      >
        <SvgLink className="size-14 text-Gray-600" />
        사이트로 이동
      </CustomLink>
    </Button>
  );
};
